export enum DocumentDependentType {
  Tender = 'tender'
}
